<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">魁省投资移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>魁省投资移民项目运行至今已有30余年历史，因为政策成熟稳定、安全可靠无风险，所以一直广受中国移民家庭的欢迎。目前在加拿大的商业移民政策中，唯有魁省投资移民项目是不需要语言成绩以及自营生意，申请人只需完成被动投资，全家均可以获得加拿大枫叶卡。

        魁北克投资移民从2012年起开始限额，每年名额一直处于“僧多粥少”的状态，竞争异常激烈！名额有限，建议申请人为抢占先机可提前递交申请！

      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1. 家庭净资产不少于200万加币，并合理证明资产来源</p>
            <p>2. 过去5年中有2年以上企业管理经验</p>
            <p>3. 一次性投资35万加币（无返还）</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、申请条件简单——没有学历、语言硬性要求</p>
            <p>2、移民一步到位——无需自营生意，一步到位获枫叶卡</p>
            <p>3、投资资金安全——先批准，后投资，在移民申请通过之前，无需资金投入</p>
            <p>4、政府担保项目——直接投资于魁省政府运营的基金项目，安全无风险</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/6.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、免费评估申请人资格</p>
            <p>2、签订服务合同和投资协议</p>
            <p>3、递交基金公司审核并获得申请名额</p>
            <p>4、向加拿大魁省移民局递交申请</p>
            <p>5、收到魁省档案号</p>
            <p>6、免面试或参加面试并通过</p>
            <p>7、投资</p>
            <p>8、收到魁省证书（CSQ）</p>
            <p>9、向联邦移民局递交申请（附CSQ）</p>
            <p>10、体检</p>
            <p>11、获得移民签证</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'CaKui'
  }
</script>

<style scoped>

</style>
